import { render, staticRenderFns } from "./OneShipin.vue?vue&type=template&id=498cd636&scoped=true&"
import script from "./OneShipin.vue?vue&type=script&lang=js&"
export * from "./OneShipin.vue?vue&type=script&lang=js&"
import style0 from "./OneShipin.vue?vue&type=style&index=0&id=498cd636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498cd636",
  null
  
)

export default component.exports